import { useState } from "react";
import { Button } from "primereact/button";

export const UNREGISTERED_STUDENT_STATUS = "UNREGISTRED";

// Lists the family students, hiding the unregistered ones behind a toggle.
const FamilyStudentList = ({ students, renderStudent, className = "flex flex-column gap-4" }) => {
  const [showUnregistered, setShowUnregistered] = useState(false);
  const list = students || [];
  const activeStudents = list.filter((student) => student?.status !== UNREGISTERED_STUDENT_STATUS);
  const unregisteredStudents = list.filter((student) => student?.status === UNREGISTERED_STUDENT_STATUS);
  const visibleStudents = showUnregistered ? [...activeStudents, ...unregisteredStudents] : activeStudents;
  const count = unregisteredStudents.length;

  return (
    <>
      <div className={className}>
        {visibleStudents.map((student) => renderStudent(student))}
      </div>
      {activeStudents.length === 0 && count > 0 && !showUnregistered && (
        <div className="text-center text-500 py-3">Aucun élève inscrit actuellement.</div>
      )}
      {count > 0 && (
        <div className="flex justify-content-center mt-3">
          <Button
            type="button"
            label={
              showUnregistered
                ? count > 1 ? "Masquer les élèves désinscrits" : "Masquer l'élève désinscrit"
                : count > 1 ? `Afficher les élèves désinscrits (${count})` : "Afficher l'élève désinscrit (1)"
            }
            icon={showUnregistered ? "pi pi-eye-slash" : "pi pi-eye"}
            text
            size="small"
            aria-expanded={showUnregistered}
            onClick={() => setShowUnregistered((value) => !value)}
          />
        </div>
      )}
    </>
  );
};

export default FamilyStudentList;
